import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, rem, getResetByTag } from '../../../styles';
var buttonStyles = function buttonStyles(_ref3) {
  var hasIcon = _ref3.hasIcon;
  return /*#__PURE__*/css("background:transparent;border:0;border-bottom:", hasIcon ? "none;" : "1px dashed transparent;", ";border-color:", colors.lightBlue_100, ";color:", colors.blue_500, ";cursor:pointer;margin:0;padding:0;text-decoration:none;&:hover,&:focus{outline:0;text-decoration:underline;}&:focus{box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";}&>svg{display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:buttonStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ch9yvl",
  styles: "border-radius:0"
} : {
  name: "hwbtve-shapeStyles",
  styles: "border-radius:0;label:shapeStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "18wgrk7",
  styles: "border-radius:50%"
} : {
  name: "1pl19i7-shapeStyles",
  styles: "border-radius:50%;label:shapeStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var shapeStyles = function shapeStyles(_ref4) {
  var shape = _ref4.shape;
  switch (shape) {
    case 'round':
      return _ref2;
    case 'square':
      return _ref;
  }
};
var resetStyles = getResetByTag('button');
var StyledTooltipButton = /*#__PURE__*/_styled('button', process.env.NODE_ENV === "production" ? {
  target: "e1k8fgsn0"
} : {
  target: "e1k8fgsn0",
  label: "StyledTooltipButton"
})(resetStyles, buttonStyles, shapeStyles);
export default StyledTooltipButton;